import { PageDictionaryItem } from '@/models/dictionary/page';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IPageDictionaryApi } from '@/types/dictionary';

export const usePageDictionary = defineStore('pageDictionary', () => {
    const itemsAll = shallowRef<PageDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    function setData(data: IPageDictionaryApi[]) {
        itemsAll.value = data.map((item) => new PageDictionaryItem(item));
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
